'use strict';

import { CONST, documentReady, addEvent } from 'app_vodafone_ziggo/util/util';
import { createModalByUrl, refreshToken } from 'Root/modal';

/**
 * @private addBsIdAsHiddenInputField
 * @param {HTMLElement} modal - The modal
 *
 * @description
 * Will add the currentBsId as a hidden input field to the form, necessary for
 * the share-advice and lets-talk forms/modals.
 */
function addBsIdAsHiddenInputField(modal) {
    const adviceStep = document.querySelector('.js-bscan-step.bscan-advice');
    const currentBsId = adviceStep ? adviceStep.getAttribute('data-bscan-id') : null;

    if (currentBsId) {
        const form = modal.querySelector('form');
        const fragment = document.createElement('input');

        fragment.setAttribute('type', 'hidden');
        fragment.setAttribute('name', 'currentBsId');
        fragment.setAttribute('value', currentBsId);

        form.appendChild(fragment);
    }
}

/**
 * @private addPlpInputFields
 * @param {HTMLElement} modal - The modal
 *
 * @description
 * Populates hidden input fields to the specified modal form containing the 'plp-basket' and plp url attribute value.
 */
function addPlpInputFields(modal) {
    const plpBasket = document.querySelector('vz-plp-sidebar')?.getAttribute('plp-basket');
    const plpBasketInput = modal.querySelector('#plpBasket');
    const plpUrlInput = modal.querySelector('#plpUrl');

    if (plpBasketInput) {
        plpBasketInput.setAttribute('value', plpBasket);
    }
    if (plpUrlInput) {
        plpUrlInput.setAttribute('value', window.location.href.split('?')[0]);
    }
}

/**
 * @private getModal
 * @param {event} event - The event
 *
 * @description
 * Will retrieve the id and url from the link, then create a modal based on the id and url
 */
function getModal(event) {
    event.preventDefault();
    const link = event.target;
    const modalId = link.getAttribute('data-modal-id');
    const modalUrl = link.getAttribute('data-modal-url');
    const isPlp = link.getAttribute('data-page-type') === 'plp';

    if (modalId && modalUrl) {
        createModalByUrl(modalId, modalUrl)
            .then((modal) => {
                if (isPlp) {
                    addPlpInputFields(modal);
                } else {
                    addBsIdAsHiddenInputField(modal);
                }
            })
            .then(refreshToken);
    }
}

/**
 * @private showModal
 * @param {string} selector - The selector for the modal
 * @param {string} errorMessage - The message to show in the console in case the modal can't be found in the dom
 *
 * @description
 * Will show a specific modal based on parameters
 */
function showModal(selector, errorMessage) {
    const modalElement = document.getElementById(selector);
    let modalInstance = window.bs.Modal.getInstance(modalElement);

    if (!modalInstance) {
        modalInstance = new window.bs.Modal(modalElement);
    }

    if (modalInstance) {
        modalInstance.show();
    } else {
        console.error(errorMessage);
    }
}

documentReady(() => {
    addEvent(document, CONST.events.click, '.js-modal-link', getModal);
});

export { showModal };
